/* eslint-disable @typescript-eslint/no-namespace */
// logger.ts
import logger from "electron-log/renderer";

declare global {
  const log: typeof logger;
  interface Window {
    log: typeof logger;
  }
}

const _self = window;

_self.log = logger;

// 统一忽略浏览器自身的 ResizeObserver 循环警告，避免被当成运行时错误
// 典型报错文案： "ResizeObserver loop completed with undelivered notifications."
// 参考：Chrome 已知问题，通常对功能没有影响
window.addEventListener(
  "error",
  (event) => {
    const msg = event.message || "";
    if (
      msg === "ResizeObserver loop completed with undelivered notifications." ||
      msg === "ResizeObserver loop limit exceeded"
    ) {
      event.stopImmediatePropagation();
    }
  },
  true
);

// 支持通过 LOG_LEVEL 环境变量控制日志级别
// 可选值: error, warn, info, verbose, debug, silly, false
const logLevel = process.env.LOG_LEVEL;

if (logLevel) {
  // 如果设置了 LOG_LEVEL，优先使用环境变量
  logger.transports.console.level = (
    logLevel === "false" ? false : logLevel
  ) as any;
} else if (
  process.env.VUE_APP_ENV === "production" ||
  process.env.VUE_APP_ENV === "test"
) {
  logger.transports.console.level = false;
} else {
  logger.transports.console.level = "silly";
}

window.onerror = (message, source, lineno, colno, error) => {
  logger.error("[window.onerror]", {
    message: message,
    source: source,
    lineno: lineno,
    colno: colno,
    error: error,
  });
};

document.addEventListener("click", function (event) {
  const dom = event.target as HTMLElement;
  if (!dom) {
    return;
  }
  const clickEvent = {
    timestamp: new Date().toISOString(),
    id: dom.id,
    tagName: dom.tagName,
    classList: Array.from(dom.classList),
    innerText: dom.innerText,
    x: event.clientX,
    y: event.clientY,
  };
  log.info("[click]", clickEvent);
});

// log.debug("log debug");
// log.info("log info");
// log.warn("log warn");
// log.error("log error");

export default logger;
